import { render, staticRenderFns } from "./NormalSearchNav64.vue?vue&type=template&id=c4e3b54c&scoped=true"
import script from "./NormalSearchNav64.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e3b54c",
  null
  
)

export default component.exports